<template>
  <div class="cp-backoffice-about-view">
    <div class="cp-backoffice-about-view-breadcrumbs-container">
      <Breadcrumbs />

      <b-button
        class="cp-backoffice-about-view-create-button"
        type="is-primary"
        outlined
        @click="goToEditAbout"
        >{{ $t('backoffice.about.edit.button') }}</b-button
      >
    </div>

    <div class="cp-backoffice-about-view-section">
      <img class="cp-backoffice-about-view-logo" :src="company.logo_image" />
      <div class="cp-backoffice-about-view-container columns is-mobile is-multiline">
        <div
          class="cp-backoffice-about-view-company-image-mobile column is-12-mobile is-hidden-tablet"
          :style="{
            backgroundImage: `url('${company.company_image}')`,
          }"
        />
        <div class=" column is-12-mobile is-hidden-mobile">
          <img class="cp-backoffice-about-view-company-image" :src="company.company_image" />
        </div>
        <div class="column is-12-mobile">
          <div
            :class="{
              'cp-backoffice-about-view-company-name': true,
              'has-text-weight-bold': true,
              'has-text-link': true,
              'is-size-4': true,
            }"
          >
            {{ company.company_name_localized }}
          </div>

          <Reader class="cp-backoffice-about-view-content" :content="company.content_localized" />
        </div>
      </div>

      <IconSet
        class="cp-backoffice-about-view-icon-set"
        :inverted="true"
        :iconImage1="company.icon_image1"
        :iconImage2="company.icon_image2"
        :iconImage3="company.icon_image3"
        :iconImage4="company.icon_image4"
        :iconText1="company.icon_text1_localized"
        :iconText2="company.icon_text2_localized"
        :iconText3="company.icon_text3_localized"
        :iconText4="company.icon_text4_localized"
      />

      <img class="cp-backoffice-about-view-background-image" :src="company.product_image" />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/backoffice/Breadcrumbs.vue';
import Reader from '@/components/Quill/Reader.vue';
import IconSet from '@/components/IconSet.vue';
import { getCompany } from '@/apis/company';

export default {
  name: 'AboutView',
  components: {
    Breadcrumbs,
    Reader,
    IconSet,
  },
  data() {
    return {
      company: {},
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    goToEditAbout() {
      this.$router.push({
        name: 'BackofficeAboutEdit',
      });
    },
    async fetchData() {
      const loading = this.$buefy.loading.open();

      try {
        const company = await getCompany();
        this.company = company;
      } finally {
        loading.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.cp-backoffice-about-view {
  flex-grow: 1;
  padding-left: 30px;
  padding-right: 30px;

  &-section {
    border: 1px solid #cacaca;
    padding: 40px;
  }

  &-breadcrumbs-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  &-edit-button {
    width: 100px;
  }

  &-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  &-logo {
    margin-top: 40px;
    margin-bottom: 30px;
    height: 80px;
    margin-left: auto;
    margin-right: auto;
    display: block;

    @media screen and (max-width: 768px) {
      height: 40px;
    }
  }

  &-company-image-mobile {
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 50vw;
  }

  &-company-name {
    padding-bottom: 5px;
    border-bottom: 1px solid $primary;
    margin-bottom: 20px;
  }

  &-product-image {
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 50vw;
  }

  &-icon-set {
    margin-bottom: 0;
  }

  &-background-image {
    width: 100%;
  }
}
</style>
